module.exports = __webpack_public_path__ + "static/media/rain.a1ea052c.svg";